import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@nazka/nazka.mapframe.components';

import './close-button.styl';

function CloseButton({
  className,
  onClick,
}) {
  return (
    <Button
      layout="ghost"
      hover={false}
      icon={faClose}
      className={`close-button${className ? ` ${className}` : ''}`}
      onClick={onClick}
      color="black"
    />
  );
}

export default CloseButton;